// daoud brand — staggered scroll-in reveal for product grids and section headings.
// Progressive enhancement: everything is fully visible by default. This script
// opts elements into a hidden→revealed transition only once it's actually
// running, so a JS failure never leaves content invisible.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Below-the-fold section headings that otherwise pop in with no transition —
  // targeted by the block's own stable wrapper class (assigned by Horizon's
  // text.liquid as .text-block--{{ block.id }}), since rte "text" fields reject
  // any class attribute injected into the heading markup itself.
  // Horizon prefixes the block id with an encoded section instance id at render
  // time (e.g. "text-block--AeXJ..._text_3L9Fjq"), so match on the stable suffix.
  var HEADING_SELECTOR =
    '[class*="__text_3L9Fjq"], ' + // footer "Rejoins le club"
    '[class*="__text_cbcgyb"]'; // PDP "On aime aussi" recommendations heading

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -40px 0px', threshold: 0.1 }
  );

  function reveal() {
    var cards = document.querySelectorAll('.product-card:not([data-reveal-bound])');
    var headings = document.querySelectorAll(HEADING_SELECTOR + ':not([data-reveal-bound])');
    if (!cards.length && !headings.length) return;

    cards.forEach(function (card, i) {
      card.dataset.revealBound = 'true';
      card.style.setProperty('--reveal-delay', Math.min(i, 10) * 40 + 'ms');
      card.classList.add('reveal-pending');
      observer.observe(card);
    });

    headings.forEach(function (heading) {
      heading.dataset.revealBound = 'true';
      heading.classList.add('reveal-pending');
      observer.observe(heading);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
  // Re-scan when Shopify re-renders sections (theme editor, section AJAX reloads).
  document.addEventListener('shopify:section:load', reveal);

  // <product-recommendations> replaces its own innerHTML (heading included) once
  // its async fetch resolves, well after the scans above — no event fires when it
  // does, so watch for it directly rather than polling.
  var bodyObserver = new MutationObserver(function () {
    window.requestAnimationFrame(reveal);
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
